module.exports = __webpack_public_path__ + "img/EXTERIOR-ERTIGA-BOOSTER-GREEN-2.4a31b457.jpg";